"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$paragraphItemLine = exports.unknownParagraphItemTitleMatch = exports.paragraphItemTitleMatch = exports.paragraphItemTitleRule = exports.$stdItem3Range = exports.$stdItem2Range = exports.$stdItem1Range = exports.$stdItemRange = exports.$stdParagraphRange = exports.$paragraphItemRanges = void 0;
const factory_1 = __importDefault(require("../factory"));
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const _sentencesArray_1 = __importDefault(require("./$sentencesArray"));
const makeRangesRule_1 = __importDefault(require("./makeRangesRule"));
const _paragraphItemTitle_1 = __importStar(require("./$paragraphItemTitle"));
const _tagControl_1 = require("./$tagControl");
const env_1 = require("../env");
const _sentenceChildren_1 = __importDefault(require("./$sentenceChildren"));
exports.$paragraphItemRanges = (0, makeRangesRule_1.default)(() => _paragraphItemTitle_1.default).$ranges;
exports.$stdParagraphRange = (0, makeRangesRule_1.default)(() => _paragraphItemTitle_1.$stdParagraphNum).$ranges;
exports.$stdItemRange = (0, makeRangesRule_1.default)(() => _paragraphItemTitle_1.$stdItemTitle).$ranges;
exports.$stdItem1Range = (0, makeRangesRule_1.default)(() => _paragraphItemTitle_1.$stdSubitem1Title).$ranges;
exports.$stdItem2Range = (0, makeRangesRule_1.default)(() => _paragraphItemTitle_1.$stdSubitem2Title).$ranges;
exports.$stdItem3Range = (0, makeRangesRule_1.default)(() => _paragraphItemTitle_1.$stdSubitem3Title).$ranges;
exports.paragraphItemTitleRule = {
    Paragraph: exports.$stdParagraphRange,
    Item: exports.$stdItemRange,
    Subitem1: exports.$stdItem1Range,
    Subitem2: exports.$stdItem2Range,
    Subitem3: exports.$stdItem3Range,
};
exports.paragraphItemTitleMatch = Object.fromEntries(Object.entries(exports.paragraphItemTitleRule).map(([tag, $rule]) => {
    const env = (0, env_1.initialEnv)({});
    return [
        tag,
        (target) => {
            const m = $rule.match(0, target, env);
            if (m.ok && m.nextOffset === target.length) {
                return m;
            }
            else {
                return {
                    ok: false,
                    offset: m.ok ? m.nextOffset : 0,
                    expected: "EOL",
                    prevFail: null,
                };
            }
        },
    ];
}));
exports.unknownParagraphItemTitleMatch = (() => {
    const env = (0, env_1.initialEnv)({});
    return (target) => {
        const m = exports.$paragraphItemRanges.match(0, target, env);
        if (m.ok && m.nextOffset === target.length) {
            return m;
        }
        else {
            return {
                ok: false,
                offset: m.ok ? m.nextOffset : 0,
                expected: "EOL",
                prevFail: null,
            };
        }
    };
})();
/**
 * The parser rule for {@link ParagraphItemLine} that represents a first line of a paragraph, item, and subitem. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$paragraphItemLine.spec.ts) for examples.
 */
exports.$paragraphItemLine = factory_1.default
    .withName("paragraphItemLine")
    .choice(c => c
    .orSequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _tagControl_1.$paragraphControl)
    .or(() => _tagControl_1.$itemControl)
    .or(() => _tagControl_1.$subitem1Control)
    .or(() => _tagControl_1.$subitem2Control)
    .or(() => _tagControl_1.$subitem3Control)
    .or(() => _tagControl_1.$subitem4Control)
    .or(() => _tagControl_1.$subitem5Control)
    .or(() => _tagControl_1.$subitem6Control)
    .or(() => _tagControl_1.$subitem7Control)
    .or(() => _tagControl_1.$subitem8Control)
    .or(() => _tagControl_1.$subitem9Control)
    .or(() => _tagControl_1.$subitem10Control)
    .orSequence(s => s
    .and(() => _tagControl_1.$autoTagControl, "control")
    .and(r => r
    .choice(c => c
    .orSequence(s => s
    .and(r => r.nextIs(r => r
    .sequence(s => s
    .and(() => exports.paragraphItemTitleRule.Paragraph)
    .and(r => r
    .choice(c => c
    .or(() => lexical_1.$__)
    .or(() => lexical_1.$_EOL))))))
    .action(() => "Paragraph"))
    .orSequence(s => s
    .and(r => r.nextIs(r => r
    .sequence(s => s
    .and(() => exports.paragraphItemTitleRule.Item)
    .and(r => r
    .choice(c => c
    .or(() => lexical_1.$__)
    .or(() => lexical_1.$_EOL))))))
    .action(() => "Item"))
    .orSequence(s => s
    .and(r => r.nextIs(r => r
    .sequence(s => s
    .and(() => exports.paragraphItemTitleRule.Subitem1)
    .and(r => r
    .choice(c => c
    .or(() => lexical_1.$__)
    .or(() => lexical_1.$_EOL))))))
    .action(() => "Subitem1"))
    .orSequence(s => s
    .and(r => r.nextIs(r => r
    .sequence(s => s
    .and(() => exports.paragraphItemTitleRule.Subitem2)
    .and(r => r
    .choice(c => c
    .or(() => lexical_1.$__)
    .or(() => lexical_1.$_EOL))))))
    .action(() => "Subitem2"))
    .orSequence(s => s
    .and(r => r.nextIs(r => r
    .sequence(s => s
    .and(() => exports.paragraphItemTitleRule.Subitem3)
    .and(r => r
    .choice(c => c
    .or(() => lexical_1.$__)
    .or(() => lexical_1.$_EOL))))))
    .action(() => "Subitem3"))
    .orSequence(s => s
    .and(r => r.assert(() => true))
    .action(() => null))), "tag")
    .action(({ tag, control }) => {
    return { tag, control };
})))))), "tagControl")
    .and(r => r
    .sequence(s => s
    .and(() => exports.$paragraphItemRanges, "title")
    .action(({ title, text }) => {
    return {
        value: text(),
        errors: title.errors,
    };
})), "title")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(c => c
    .and(() => lexical_1.$__, "midSpace")
    .and(() => _sentencesArray_1.default, "columns")
    .action(({ midSpace, columns }) => {
    return { midSpace, columns };
}))), "contentStruct")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, tagControl, title, contentStruct, lineEndText }) => {
    const errors = [
        ...indentsStruct.errors,
        ...title.errors,
        ...(contentStruct?.columns.errors ?? []),
    ];
    const tag = tagControl?.tag ?? null;
    return {
        value: new line_1.ParagraphItemLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            mainTag: tag,
            controls: tagControl ? [tagControl.control] : [],
            title: title.value,
            midSpace: contentStruct?.midSpace ?? "",
            sentencesArray: contentStruct?.columns.value ?? [],
            lineEndText,
        }),
        errors,
    };
}))
    .orSequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _tagControl_1.$paragraphControl)
    .or(() => _tagControl_1.$itemControl)
    .or(() => _tagControl_1.$subitem1Control)
    .or(() => _tagControl_1.$subitem2Control)
    .or(() => _tagControl_1.$subitem3Control)
    .or(() => _tagControl_1.$subitem4Control)
    .or(() => _tagControl_1.$subitem5Control)
    .or(() => _tagControl_1.$subitem6Control)
    .or(() => _tagControl_1.$subitem7Control)
    .or(() => _tagControl_1.$subitem8Control)
    .or(() => _tagControl_1.$subitem9Control)
    .or(() => _tagControl_1.$subitem10Control)))), "tagControl")
    .and(r => r
    .sequence(s => s
    .and(() => _sentenceChildren_1.default, "title")
    .action(({ title, text }) => {
    return {
        value: text(),
        errors: title.errors,
    };
})), "title")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(c => c
    .and(() => lexical_1.$__, "midSpace")
    .and(() => _sentencesArray_1.default, "columns")
    .action(({ midSpace, columns }) => {
    return { midSpace, columns };
}))), "contentStruct")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, tagControl, title, contentStruct, lineEndText }) => {
    const errors = [
        ...indentsStruct.errors,
        ...title.errors,
        ...(contentStruct?.columns.errors ?? []),
    ];
    return {
        value: new line_1.ParagraphItemLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            mainTag: tagControl.tag,
            controls: [tagControl.control],
            title: title.value,
            midSpace: contentStruct?.midSpace ?? "",
            sentencesArray: contentStruct?.columns.value ?? [],
            lineEndText,
        }),
        errors,
    };
}))
    .orSequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .choice(c => c
    .or(() => _tagControl_1.$anonymParagraphControl)
    .or(() => _tagControl_1.$anonymItemControl)
    .or(() => _tagControl_1.$anonymSubitem1Control)
    .or(() => _tagControl_1.$anonymSubitem2Control)
    .or(() => _tagControl_1.$anonymSubitem3Control)
    .or(() => _tagControl_1.$anonymSubitem4Control)
    .or(() => _tagControl_1.$anonymSubitem5Control)
    .or(() => _tagControl_1.$anonymSubitem6Control)
    .or(() => _tagControl_1.$anonymSubitem7Control)
    .or(() => _tagControl_1.$anonymSubitem8Control)
    .or(() => _tagControl_1.$anonymSubitem9Control)
    .or(() => _tagControl_1.$anonymSubitem10Control)), "tagControl")
    .and(r => r
    .zeroOrOne(() => _sentencesArray_1.default), "columns")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, tagControl, columns, lineEndText }) => {
    const errors = [
        ...indentsStruct.errors,
        ...(columns?.errors ?? []),
    ];
    return {
        value: new line_1.ParagraphItemLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            mainTag: tagControl.tag,
            controls: [tagControl.control],
            title: "",
            midSpace: "",
            sentencesArray: columns?.value ?? [],
            lineEndText,
        }),
        errors,
    };
})));
exports.default = exports.$paragraphItemLine;
//# sourceMappingURL=$paragraphItemLine.js.map